module.exports = __webpack_public_path__ + "img/logo2.b3121190.svg";